import { Upload as UploadProps } from '@sportsyou/api'

export const getContentType = (upload: UploadProps = {}) => {
  return upload.contentType ?? ''
}

export default getContentType
